<template>
  <div>
    <v-app-bar class="text-center" :elevation="1">
      <!-- Clickable Logo -->
      <v-img
        :src="require('@/assets/suuq.logo.svg')"
        alt="SUUQ Logo"
        @click="logoRoute"
      />
    </v-app-bar>

    <v-row class="main-content">
      <v-col cols="12" class="mx-auto">
        <v-card elevation="0" :width="this.$vuetify.display.mobile ? 400 : 700" class="mx-auto mt-n1">
          <v-card-title class="mb-1">
            <div>
              Notifications
              <div class="text-caption text-grey mt-n1">
                View what's new today!
              </div>
            </div>
          </v-card-title>
          <v-card-text>
            <div class="text-center">
              <span class="text-center text-error">No Notifications</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  data() {
    return {
      myNotifications: [],
    };
  },
  computed: {
    loggedInUser() {
      return this.$store.state.auth.user;
    },
  },

  methods: {
    logoRoute() {
      this.$router.push("/");
    },

  },
};
</script>

<style scoped>
/* Ensuring buttons and elements maintain transparent backgrounds */
.v-btn::before {
  background-color: transparent;
}

/* Style for main content area */
.main-content {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
